import * as ClientConfig from "../config/ClientConfig.js";
import * as RestClient from "../util/api/restClient"
import * as StorageService from "./StorageService";
import {LOCALSTORAGE_ITEMS} from "../util/Constants";
import {generateZonizCaptcha} from "./AccountService";


const loginWithUserAndPassword =  async (body) => {
    return RestClient.handleResponse(() => {
        const finalURL = ClientConfig.URL_RESOURCE_SERVER + "/api/user/znlogin";
        const response = fetch(finalURL, {
            method: "POST",
            body: JSON.stringify(body),
        });
        return response;
    });
}

const signUpWithEmailAndPassword =  async (body) => {
    const captcha = generateZonizCaptcha();
    return RestClient.handleResponse(() => {
        const finalURL = ClientConfig.URL_RESOURCE_SERVER + "/api/user/znsignup";
        const response = fetch(finalURL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Zoniz-Captcha":captcha,
            },
            body: JSON.stringify(body),
        });
        return response;
    });
}


const confirmUserDataAndCreateUser =  async (method, data) => {
    //used for email content link
    return RestClient.handleResponse(() => {
        const finalURL = ClientConfig.URL_RESOURCE_SERVER + "/api/user/znconfirm"+
            (data ? "data=" + data : "");
        const response = fetch(finalURL, {
            method: method, // GET OR POST

        });
        return response;
    });
}

const recoverUserPassword =  async (body) => {
    const captcha = generateZonizCaptcha();
    return RestClient.handleResponse(() => {
        const finalURL = ClientConfig.URL_RESOURCE_SERVER + "/api/user/znrecover";
        const response = fetch(finalURL, {
            headers: {
                "Content-Type": "application/json",
                "X-Zoniz-Captcha":captcha,
            },
            method: "POST",
            body: JSON.stringify(body),
        });
        return response;
    });
}

const confirmResetUserPassword =  async (method, data) => {
    //used for email content link
    return RestClient.handleResponse(() => {
        const finalURL = ClientConfig.URL_RESOURCE_SERVER + "/api/user/znreset"+
            (data ? "data=" + data : "");
        const response = fetch(finalURL, {
            method: method, // GET OR POST
        });
        return response;
    });
}

const createUpdatePhoneToken =  async (body) => {
    return RestClient.handleResponse(() => {
        const finalURL = ClientConfig.URL_RESOURCE_SERVER + "/api/user/createupdatephonetoken";
        const response = fetch(finalURL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Zoniz-Token": StorageService.getItem(LOCALSTORAGE_ITEMS.ACCESS_TOKEN),
                "X-Zoniz-User-Email": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            },
            body: JSON.stringify(body),
        });
        return response;
    });
}

const updatePhoneByCodeAndToken =  async (body) => {
    return RestClient.handleResponse(() => {
        const finalURL = ClientConfig.URL_RESOURCE_SERVER + "/api/user/updatephonebycodeandtoken";
        const response = fetch(finalURL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Zoniz-Token": StorageService.getItem(LOCALSTORAGE_ITEMS.ACCESS_TOKEN),
                "X-Zoniz-User-Email": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            },
            body: JSON.stringify(body),
        });
        return response;
    });
}

const updateUserInformation =  async (body) => {
    return RestClient.handleResponse(() => {
        const finalURL = ClientConfig.URL_RESOURCE_SERVER + "/api/user/znupdate";
        const response = fetch(finalURL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Zoniz-Token": StorageService.getItem(LOCALSTORAGE_ITEMS.ACCESS_TOKEN),
                "X-Zoniz-User-Email": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            },
            body: JSON.stringify(body),
        });
        return response;
    });
}

const updateUserInformationWithoutHeaders =  async (body) => {
    return RestClient.handleResponse(() => {
        const finalURL = ClientConfig.URL_RESOURCE_SERVER + "/api/user/znupdate";
        const response = fetch(finalURL, {
            method: "POST",
            body: JSON.stringify(body),
        });
        return response;
    });
}


const generateAnonymousEmail =  async (captcha) => {
    return RestClient.handleResponse(() => {

        const finalURL = ClientConfig.URL_RESOURCE_SERVER + "/api/user/znanonymousemail"
        const response = fetch(finalURL, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-Zoniz-Captcha":captcha,
            }
        });
        return response;
    });
}

const createAnonymousAccount =  async (body) => {
    return RestClient.handleResponse(() => {
        const finalURL = ClientConfig.URL_RESOURCE_SERVER + "/api/user/znanonymouslogin";
        const response = fetch(finalURL, {
            method: "POST",
            body: JSON.stringify(body),
        });
        return response;
    });
}


const getAvailableTables =  async (req) => {
    return RestClient.handleResponse(() => {
        const finalURL = ClientConfig.URL_RESOURCE_SERVER + "/api/user/getavailabletables";
        const response = fetch(finalURL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Zoniz-Token": StorageService.getItem(LOCALSTORAGE_ITEMS.ACCESS_TOKEN),
                "X-Zoniz-User-Email": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            },
            body: JSON.stringify(req),
        });
        return response;
    });
}

const getTableById = (req) => {
    return RestClient.handleResponse(() => {
        const finalURL = ClientConfig.URL_RESOURCE_SERVER + "/api/user/gettable";
        const response = fetch(finalURL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Zoniz-Token": StorageService.getItem(LOCALSTORAGE_ITEMS.ACCESS_TOKEN),
                "X-Zoniz-User-Email": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            },
            body: JSON.stringify(req),
        });

        return response;
    });
}





export {
    loginWithUserAndPassword,
    signUpWithEmailAndPassword,
    confirmUserDataAndCreateUser,
    recoverUserPassword,
    confirmResetUserPassword,
    updateUserInformation,
    updateUserInformationWithoutHeaders,
    generateAnonymousEmail,
    createAnonymousAccount,
    getAvailableTables,
    getTableById,
    createUpdatePhoneToken,
    updatePhoneByCodeAndToken
}
